import React from 'react';
import {
  TEMPERAMENT_LABEL,
  GOODWITH_LABEL,
  REGIME_LABEL,
} from '../api/petAdapter';
import type { Pet } from '../types';
import '../styles/PetTraits.css';

interface PetTraitsProps {
  pet: Pet;
}

interface Section {
  label: string;
  items: string[];
}

const PetTraits: React.FC<PetTraitsProps> = ({ pet }) => {
  const sections: Section[] = [];

  const traits: string[] = [];
  if (pet.energyLabel) traits.push(pet.energyLabel.toLowerCase());
  for (const t of pet.temperaments) traits.push(TEMPERAMENT_LABEL[t]);
  if (traits.length) sections.push({ label: 'Personalidade', items: traits });

  if (pet.goodWith.length) {
    sections.push({
      label: 'Dá-se com',
      items: pet.goodWith.map((g) => GOODWITH_LABEL[g]),
    });
  }

  if (pet.breeds.length) {
    sections.push({ label: 'Raça', items: pet.breeds });
  }

  if (pet.regimes.length) {
    sections.push({
      label: 'Aceita',
      items: pet.regimes.map((r) => REGIME_LABEL[r]),
    });
  }

  if (sections.length === 0) return null;

  return (
    <div className="pet-traits">
      {sections.map((s) => (
        <div className="pet-traits__group" key={s.label}>
          <div className="pet-traits__label">{s.label}</div>
          <div className="pet-traits__chips">
            {s.items.map((item) => (
              <span className="pet-traits__chip" key={item}>
                {item}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PetTraits;
